import { Component } from "@angular/core";
import { UntilDestroy } from "@ngneat/until-destroy";
import { ProfileTheme, ProfileThemeService } from "../services/profile-theme.service";

@UntilDestroy()
@Component({
  selector: "profile-theme",
  templateUrl: "./profile-theme.component.html",
  styleUrls: ["./profile-theme.component.less"],
})
export class ProfileThemeComponent {
  public profileTheme: string;

  constructor(protected profileThemeService: ProfileThemeService) {
    this.profileTheme = this.profileThemeService.getProfileThemeCurrentValue();
  }

  public themeChanged(newTheme: ProfileTheme): void {
    this.profileThemeService.setProfileTheme(newTheme);
  }
}
